import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { DialogService } from '@core/services/dialog.service';
import { MenuPrincipalService } from '@core/services/menu-principal.service';
import { AppSharedDataService } from 'src/app/app-shared-data.service';
import { ThemeService } from 'src/app/theme.service';

@Component({
  selector: 'app-menu-aside',
  templateUrl: './menu-aside.component.html',
  styleUrls: ['./menu-aside.component.scss']
})
export class MenuAsideComponent implements OnInit {

  isCollapsed: boolean = false;
  menuPrincipal: any[] = [];
  nameTheme: any;

  constructor(
    private menuPrincipalService: MenuPrincipalService,
    private themeService: ThemeService,
    private router: Router,
    private dialogService: DialogService,
    private appSharedDataService: AppSharedDataService,
    private localStorageService: LocalStorageService,
    private authenticationService: AuthenticationService,
  ) { }

  ngOnInit() {
    this.menuPrincipalService?.menuPrincipal().subscribe((res) => {
      this.menuPrincipal = res
    });
  }

  accessUrl(url: string) {
    if (url.includes('cena')) {
      this.router.navigateByUrl(url)
    }
    else if (url.includes('sair')) {
      this.logout();
    }
    else {
      this.router.navigate([url])
    }
  }

  logout(): void {
    this.dialogService.confirm('Deseja realmente sair do sistema?', () => {
      this.authenticationService.logout();
    })
  }

  isCollapsedFn(acao?: boolean) {
    (acao)
      ? this.isCollapsed = acao
      : this.isCollapsed = !this.isCollapsed;

    this.appSharedDataService.setMinimizeMenu(this.isCollapsed);
  }
}
